<template>
  <div class="footer_model">
    <div class=" footer bg-white" :style="{ borderColor: color }">
      <div class="container">
        <div v-html="language == 'cn' ? (config.setForm ? config.setForm.cn_copyright : '') : (config.setForm ? config.setForm.en_copyright : '')"></div>
        
      </div>
    </div>

    <!--微信公众号二维码弹框-->
    <div class="modal" id="wechatModel" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-center">关注我们</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body text-center">
            <!--替换成公众号的二维码-->
            <img src="../assets/img/wechat.png" />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: ["backSave", "nextSave"],
  computed: {
    ...mapState({
      color: (state) => state.color,
      config: (state) => state.config,
    }),
  },
  data() {
    return {
      projectId: "",
      language: sessionStorage.getItem("language") || "cn",
      data: {},
    };
  },

  created() {
    this.projectId = sessionStorage.getItem("projectId") || 0;
  },
  async mounted() {
    await this.getProjectBaseConfig();
  },
  methods: {
    async getProjectBaseConfig() {
      let res = await this.$api.getprojectconfiginfo({ projectId: this.projectId, key: "basic" });
      if (res.code == 200 && res.data) {
        this.$store.commit("setConfig", JSON.parse(res.data.typevalue));

      }
    },
  }
};
</script>

<style scoped>
.container {
  padding: 15px 0;
  background-color: #fff !important;
}

.footer_model {
  width: 100%;
}
</style>